import TitleSplit from "./TitleSplit.component";

export default TitleSplit;
